'use client';

import { useEffect, useState } from 'react';
import { filterPriceArr } from '../../lib/consts';
import { H1 } from '../styled/typography';
import CheckSVG from '../../public/img/check-red.svg';
import { FilterQuery, ICostFilter } from '../../models/filters';

export default function CostFilter({
  query,
  setQuery,
  filtersData,
}: {
  query: FilterQuery;
  setQuery: (query: FilterQuery) => void;
  filtersData: ICostFilter | null;
}) {
  const [activeCost, setActiveCost] = useState<number | null>(null);

  useEffect(() => {
    if (filtersData) {
      setActiveCost(filtersData.id);
    } else {
      setActiveCost(null);
    }
  }, [filtersData]);

  return (
    <div>
      <H1
        css={{
          fontFamily: 'Montserrat',
          fontSize: '24px !important',
          fontWeight: 900,
        }}
      >
        Стоимость
      </H1>
      <div
        css={{
          width: '100%',
          height: 2,
          boxShadow: '0 1px 1px rgba(0, 0, 0, 0.05)',
          marginTop: 14,
        }}
      />
      <div
        css={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
        }}
      >
        {filterPriceArr.map((item) => (
          <button
            type='button'
            key={`cost-filter-${item.id}`}
            css={{
              width: '100%',
              height: 75,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              boxShadow: '0 1px 1px rgba(0, 0, 0, 0.05)',
              textAlign: 'left',
              fontSize: 18,
              fontWeight: 700,
              fontFamily: 'Montserrat',
              color: '#333',
              letterSpacing: 0,
            }}
            onClick={() => {
              setQuery({
                ...query,
                filters: {
                  ...query.filters,
                  filter_price__gte:
                    query.filters.filter_price__gte === item.price1
                      ? []
                      : item.price1,
                  filter_price__lte:
                    query.filters.filter_price__lte === item.price2
                      ? []
                      : item.price2,
                  pages: [],
                },
                isDataFromServer: false,
              });
            }}
          >
            {item.title}

            {item.id === activeCost && <CheckSVG />}
          </button>
        ))}
      </div>
    </div>
  );
}
